import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';

import { AgreementComponent } from './agreement.component';
import { ActionButtonModule } from '../../../../../shared/action-button';
import { DatePickerModule } from '../../../../../shared/date-picker';
import { LiveSearchSelectModule } from '../../../../../shared/live-search-select';
import { LesseeProviders } from '../../../../../_models';

@NgModule({
    declarations: [AgreementComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ActionButtonModule,
        DatePickerModule,
        LiveSearchSelectModule,
        SweetAlert2Module.forRoot()
    ],
    exports: [AgreementComponent],
    providers: [LesseeProviders]
})
export class AgreementModule { }



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/units/agreement/agreement.module.ts